import { router, useLocalSearchParams, useNavigation } from 'expo-router';
import { useEffect, useLayoutEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import GoBackButton from '@/components/buttons/GoBackButton';
import FormWrapper from '@/components/forms/FormWrapper';
import ProgramForm from '@/components/forms/ProgramForm';
import Title from '@/components/Title';
import { ProgramData } from '@/lib/validations/NpoOnboardingSchema';
import { i18n } from '@/utils/i18n';
import { safeJsonParse } from '@/utils/jsonParse';

const AddUpdateProgram = () => {
  const navigation = useNavigation<any>();
  const { programDataJson, programIndex } = useLocalSearchParams<{
    programDataJson: string;
    programIndex: string;
  }>();
  const [initialProgramData, setInitialProgramData] = useState<ProgramData | undefined>(undefined);

  useLayoutEffect(() => {
    navigation.setOptions({
      headerShown: true,
      headerTransparent: true,
      headerTitle: () => <Title label={i18n.t('sign_in.nonProfit.programs.add_title')} />,
      headerLeft: () => <GoBackButton navigateTo={'/login/nonProfit/onBoarding/programs'} />,
      headerBackVisible: false
    });
  }, [navigation]);

  useEffect(() => {
    if (programDataJson) {
      const parsedProgram = safeJsonParse<ProgramData>(programDataJson);
      if (parsedProgram) setInitialProgramData(parsedProgram);
    }
  }, [programDataJson]);

  return (
    <SafeAreaView style={styles.content}>
      <FormWrapper keyboardVerticalOffset={0} scrollEnable={false}>
        <View style={styles.container}>
          <ProgramForm
            initialData={initialProgramData}
            showDoneButton
            onDone={(data) => {
              router.dismissTo({
                pathname: '/(app)/login/nonProfit/onBoarding/programs',
                params: {
                  programDataJson: JSON.stringify(data),
                  programIndex: programIndex
                }
              });
            }}
          />
        </View>
      </FormWrapper>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  content: {
    flex: 1
  },

  container: {
    flex: 1,
    marginTop: 60
  }
});

export default AddUpdateProgram;
